import React from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useModal } from '@src/state/modal';
import { ErrorIcon } from './ErrorIcon';

const Container = styled('div', {
  padding: '10px 20px 15px 20px',
  fontSize: '16px',
});

const StyledModal = styled(Modal, {
  top: '30%',
});

const StyledBody = styled('div', {
  padding: '18px',
});

const StyledIcon = styled('div', {
  position: 'relative',
  width: 70,
  height: 70,
  borderRadius: '50%',
  background: '#F1FAFC',
  padding: '10px 15px',
  marginLeft: '165px',
});

const SpacingDiv = styled('div', {
  paddingTop: '10px',
  paddingLeft: '5px',
});

export const SpouseOnlyModal = () => {
  const { modals, modalData } = useModal.state();
  const { toggleModal } = useModal.actions();

  const handleClose = () => {
    toggleModal({ key: 'spouseOnly', isOpen: false });
  };

  return (
    <StyledModal
      id='spouse-only-modal'
      data-testid='spouse-only-modal'
      isOpen={modals.spouseOnly}
      onClose={handleClose}
      size={450}
    >
      <StyledBody>
        <StyledIcon>
          <ErrorIcon />
        </StyledIcon>
        <Container>
          <Choose>
            <When
              condition={
                modalData.spouseOnly && modalData.spouseOnly.errorMessage
              }
            >
              <b>{modalData.spouseOnly.errorMessage}</b>
            </When>
            <Otherwise>
              <b>
                Member was found, but there is no active coverage for the
                searched Dates of Service,{' '}
                {modalData.spouseOnly && modalData.spouseOnly.serviceStart} -{' '}
                {modalData.spouseOnly &&
                  (modalData.spouseOnly.serviceEnd ||
                    modalData.spouseOnly.serviceStart)}
                .
              </b>
              <SpacingDiv>
                Please enter new Dates of Service and resubmit.
              </SpacingDiv>
            </Otherwise>
          </Choose>
        </Container>
      </StyledBody>
    </StyledModal>
  );
};
